import React, { useEffect, useState } from 'react';
import { Heading, Layout } from '@americanexpress/dls-react';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';

const getGoogleMapsApiKey = () => 'AIzaSyB9eAyHfQxJdrgyqWnLzBhfsRf1rLP0JyM';

const getGoogleMapsMapId = () => 'c422ff4d3885d1274c689f17';

const formatCoordinate = (value) => (
  typeof value === 'number' ? value.toFixed(5) : null
);

const HotelLocationMap = ({ hotelName, coordinates }) => {
  const googleMapsApiKey = getGoogleMapsApiKey();
  const googleMapsMapId = getGoogleMapsMapId();

  return (
    <APIProvider apiKey={googleMapsApiKey}>
      <div style={{ height: '320px' }} className="radius-container no-scroll">
        <Map
          defaultCenter={coordinates}
          defaultZoom={15}
          defaultZoom={15}
          gestureHandling="cooperative"
          disableDefaultUI={true}
          mapId={googleMapsMapId}
          className="width-full height-full"
        >
          <Marker position={coordinates} title={hotelName} />
        </Map>
      </div>
    </APIProvider>
  );
};

const HotelLocationSection = ({
  hotelName,
  coordinates,
  addressLines = [],
  phone,
}) => {
  if (!coordinates) {
    return null;
  }

  return (
    <section id="location" className="margin-4-t" style={{ scrollMarginTop: 'calc(64px + 1rem)' }}>
      <Heading level={2} variant="sans-medium-bold">
        Location
      </Heading>
      <div className="row margin-2-t">
        <div className="col-12">
          <HotelLocationMap hotelName={hotelName} coordinates={coordinates} />
        </div>
        {addressLines.length > 0 ? (
          <div className="col-xs-12 col-md-6 margin-t">
            <Heading level={3} variant="sans-small-bold">
              Address
            </Heading>
            {addressLines.map((line, index) => (
              <p key={`${line}-${index}`} className="body margin-0">
                {line}
              </p>
            ))}
          </div>
        ) : null}
        {phone ? (
          <div className="col-xs-12 col-md-6 margin-t">
            <Heading level={3} variant="sans-small-bold">
              Phone
            </Heading>
            <p className="body margin-0">{phone}</p>
          </div>
        ) : null}
      </div>
    </section>
  );
};

export { formatCoordinate };
export default HotelLocationSection;
